// Generated by pnpm generate:icons from sources.json. Do not edit.
import {
  AcademicCapIcon,
  AgreementIcon,
  AgreementFilledIcon,
  AiChatIcon,
  AiSuggestionIcon,
  AiSuggestionFilledIcon,
  AmexIcon,
  AnalyticsIcon,
  AnalyticsFilledIcon,
  ApiIcon,
  ApiBulkIcon,
  ApiFilledIcon,
  ArchiveIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  ArrowUpRightIcon,
  AttachmentIcon,
  AudioBookIcon,
  BankIcon,
  BankCardShareMoneyIcon,
  BankCardShareMoneyBulkIcon,
  BankCardShareMoneyFilledIcon,
  BathIcon,
  BedIcon,
  BlockedIcon,
  BoardMenuIcon,
  BoardMenuBulkIcon,
  BoardMenuFilledIcon,
  BoardPinIcon,
  BoardPinBulkIcon,
  BoardPinFilledIcon,
  BoardTasksIcon,
  BoardTasksBulkIcon,
  BoardTasksFilledIcon,
  BookIcon,
  BookOpenIcon,
  BookmarkIcon,
  BotIcon,
  BriefcaseIcon,
  BriefcaseBulkIcon,
  BriefcaseFilledIcon,
  BrowserIcon,
  BuildingIcon,
  BuildingFilledIcon,
  BunkBedIcon,
  CalculatorIcon,
  CalendarIcon,
  CalendarAddFlipIcon,
  CalendarCheckIcon,
  CalendarCloseIcon,
  CalendarFilledIcon,
  CalendarMinusIcon,
  CalendarPercentIcon,
  CalendarQuestionIcon,
  CalendarStarIcon,
  CalendarSyncIcon,
  CalendarUserIcon,
  CardWalletIcon,
  CardWalletBulkIcon,
  CardWalletFilledIcon,
  CardsIcon,
  CardsBulkIcon,
  CardsFilledIcon,
  CashierIcon,
  CashierBulkIcon,
  CashierFilledIcon,
  ChartIcon,
  ChartColumnIcon,
  ChartLineIcon,
  ChartLineFilledIcon,
  ChatIcon,
  ChatAddIcon,
  ChatOffIcon,
  ChatQuestionIcon,
  ChatTextIcon,
  CheckIcon,
  CheckBadgeIcon,
  CheckCircleIcon,
  CheckDoubleIcon,
  CheckListIcon,
  CheckSquareIcon,
  CheckSquareFilledIcon,
  ChemistryFlaskIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  ChevronsLeftIcon,
  ChevronsRightIcon,
  ChevronsUpDownIcon,
  CircleIcon,
  CityIcon,
  CityBulkIcon,
  CityFilledIcon,
  ClapIcon,
  ClipboardIcon,
  ClipboardClockIcon,
  ClipboardClockFilledIcon,
  ClockIcon,
  ClockClockwiseIcon,
  ClockFilledIcon,
  ClockPresentationIcon,
  ClockWorldIcon,
  CloseIcon,
  CloseCircleIcon,
  CloudIcon,
  CloudCheckIcon,
  CloudDownloadIcon,
  CloudDownloadBulkIcon,
  CloudDownloadFilledIcon,
  CloudServerIcon,
  CloudUploadIcon,
  CodeIcon,
  CoinsIcon,
  CollapseIcon,
  CommandIcon,
  CompassIcon,
  ComputerIcon,
  ComputerDollarIcon,
  ComputerDollarFilledIcon,
  ConnectedCableIcon,
  CopyIcon,
  CreditCardIcon,
  CreditCardEditIcon,
  CreditCardFilledIcon,
  DashboardIcon,
  DashboardFilledIcon,
  DatabaseIcon,
  DatabaseImportIcon,
  DatabaseImportFilledIcon,
  DeleteIcon,
  DeliveryIcon,
  DiscountIcon,
  DiscoverIcon,
  DivideIcon,
  DocumentIcon,
  DocumentAddIcon,
  DocumentAddBulkIcon,
  DocumentAddFilledIcon,
  DocumentAttachmentIcon,
  DocumentAttachmentFilledIcon,
  DocumentBulkIcon,
  DocumentCheckIcon,
  DocumentClockIcon,
  DocumentDownloadIcon,
  DocumentEditIcon,
  DocumentEditBulkIcon,
  DocumentEditFilledIcon,
  DocumentExportIcon,
  DocumentFilledIcon,
  DocumentPdfIcon,
  DocumentRemoveIcon,
  DocumentTextIcon,
  DocumentUploadIcon,
  DocumentZipIcon,
  DogIcon,
  DollarIcon,
  DollarCircleIcon,
  DollarSquareIcon,
  DollarUpIcon,
  DollarUpBulkIcon,
  DollarUpFilledIcon,
  DoorIcon,
  DoorOpenIcon,
  DownloadIcon,
  DownloadFilledIcon,
  DragVerticalIcon,
  DropletIcon,
  EditIcon,
  EditSquareIcon,
  ExpandIcon,
  ExternalLinkIcon,
  EyeIcon,
  EyeOffIcon,
  FaceIdLockIcon,
  FaceIdLockBulkIcon,
  FaceIdLockFilledIcon,
  FilterIcon,
  FilterClearIcon,
  FingerprintIcon,
  FingerprintFilledIcon,
  FlashIcon,
  FolderIcon,
  FolderAddIcon,
  FolderBlockedIcon,
  FolderFilledIcon,
  FolderLibraryIcon,
  FolderLibraryFilledIcon,
  FolderLockIcon,
  FolderOpenIcon,
  FolderTransferIcon,
  FullscreenIcon,
  FullscreenExitIcon,
  GiftIcon,
  GlobeIcon,
  GlobeFilledIcon,
  GridIcon,
  HashtagIcon,
  HelpCircleIcon,
  HistoryIcon,
  HomeIcon,
  HomeBulkIcon,
  HomeFilledIcon,
  HomeFunIcon,
  HomeFunBulkIcon,
  HomeFunFilledIcon,
  HomeSearchIcon,
  IdeaIcon,
  ImageIcon,
  ImageMissingIcon,
  InboxIcon,
  InboxFilledIcon,
  InfoCircleIcon,
  InvoiceIcon,
  KeyIcon,
  KeyFilledIcon,
  LayersIcon,
  LayersAddIcon,
  LegalHammerIcon,
  LicenseIcon,
  LinkIcon,
  LinkAddIcon,
  ListIcon,
  ListBulletIcon,
  ListNumberIcon,
  LoadingIcon,
  LocationIcon,
  LockIcon,
  LockSquareIcon,
  LogoutIcon,
  MagicSelectionIcon,
  MagicWandIcon,
  MailIcon,
  MailAccountIcon,
  MailAccountFilledIcon,
  MailAiIcon,
  MailBulkIcon,
  MailCheckIcon,
  MailCloseIcon,
  MailDocumentIcon,
  MailDocumentFilledIcon,
  MailEditIcon,
  MailFilledIcon,
  MailOpenIcon,
  MailOpenBulkIcon,
  MailOpenFilledIcon,
  MailReceiveIcon,
  MailReceiveBulkIcon,
  MailReceiveFilledIcon,
  MailSendIcon,
  MailSendBulkIcon,
  MailSendFilledIcon,
  MapIcon,
  MastercardIcon,
  MegaphoneIcon,
  MegaphoneFilledIcon,
  MenuIcon,
  MinusIcon,
  MinusCircleIcon,
  MobileIcon,
  MobileCodeIcon,
  MobileSendIcon,
  MoneyIcon,
  MoneyBagIcon,
  MoneyExchangeIcon,
  MoneyExchangeFilledIcon,
  MoneyFilledIcon,
  MoneyReceiveIcon,
  MoneySendIcon,
  MoneySendCircleIcon,
  MoonIcon,
  MoreHorizontalIcon,
  MoreHorizontalCircleIcon,
  MoreVerticalIcon,
  MusicNoteIcon,
  NetworkEditIcon,
  NoteIcon,
  NoteFilledIcon,
  NotificationIcon,
  NotificationBulkIcon,
  NotificationFilledIcon,
  NotificationOffIcon,
  OfficeIcon,
  OfficeFilledIcon,
  PackageIcon,
  PaintBrushIcon,
  PaletteIcon,
  PaperCurvedIcon,
  PaperCurvedBulkIcon,
  PaperCurvedFilledIcon,
  ParkingIcon,
  PasswordIcon,
  PauseCircleIcon,
  PaymentIcon,
  PlayIcon,
  PlayCircleIcon,
  PlugIcon,
  PlugFilledIcon,
  PlusIcon,
  PlusCircleIcon,
  PrinterIcon,
  PushpinIcon,
  PushpinFilledIcon,
  QuickbooksIcon,
  ReceiptIcon,
  ReceiptDollarIcon,
  ReceiptDollarFilledIcon,
  ReceiptFilledIcon,
  ReceiptSuccessIcon,
  RedoIcon,
  RefreshIcon,
  RefreshFilledIcon,
  RepeatIcon,
  RepeatBulkIcon,
  RepeatFilledIcon,
  ReportsAnalysisIcon,
  RingtoneIcon,
  RocketIcon,
  RotateClockwiseIcon,
  RulerIcon,
  SafeIcon,
  SaveIcon,
  SavingsIcon,
  ScissorsIcon,
  SearchIcon,
  SearchListIcon,
  SendIcon,
  SendFilledIcon,
  SettingsIcon,
  SettingsFilledIcon,
  SettingsGearIcon,
  SettingsGearBulkIcon,
  SettingsGearFilledIcon,
  ShareIcon,
  ShieldIcon,
  ShieldAddIcon,
  ShieldBlockedIcon,
  ShieldCheckIcon,
  ShieldCheckFilledIcon,
  ShieldDoneIcon,
  ShieldDoneBulkIcon,
  ShieldDoneFilledIcon,
  ShieldUserIcon,
  ShieldUserBulkIcon,
  ShieldUserFilledIcon,
  ShieldWarningIcon,
  SidebarAgreementIcon,
  SidebarBuildingIcon,
  SidebarCalendarIcon,
  SidebarChartIcon,
  SidebarClockIcon,
  SidebarDocumentIcon,
  SidebarHistoryIcon,
  SidebarHomeIcon,
  SidebarInboxIcon,
  SidebarLeftIcon,
  SidebarPeopleIcon,
  SidebarPinIcon,
  SidebarPinFilledIcon,
  SidebarTasksIcon,
  SidebarUnitIcon,
  SidebarUserIcon,
  SidebarUserActiveIcon,
  SidebarUserInactiveIcon,
  SidebarVendorIcon,
  SidebarViewsIcon,
  SidebarWalletIcon,
  SidebarWorkIcon,
  SignatureIcon,
  SortIcon,
  SortDownIcon,
  SortUpIcon,
  SparklesIcon,
  StarIcon,
  StarFilledIcon,
  StarMagicGlowIcon,
  StarMagicGlowFilledIcon,
  StopIcon,
  StopCircleIcon,
  StopFilledIcon,
  StoreIcon,
  StructureIcon,
  SunIcon,
  SwapHorizontalIcon,
  SwapHorizontalFilledIcon,
  TableIcon,
  TableFilledIcon,
  TabletIcon,
  TagIcon,
  TargetIcon,
  TargetFilledIcon,
  TargetSearchIcon,
  TargetSearchBulkIcon,
  TargetSearchFilledIcon,
  TaskIcon,
  TaskAddIcon,
  TaskBulkIcon,
  TaskCheckIcon,
  TaskEditIcon,
  TaskFilledIcon,
  TaskListIcon,
  TaxesIcon,
  TelephoneIcon,
  TextAlignLeftIcon,
  TextBoldIcon,
  TextItalicIcon,
  ThumbDownIcon,
  ThumbUpIcon,
  ToolsIcon,
  UndoIcon,
  UploadIcon,
  UserIcon,
  UserAddIcon,
  UserBlockedIcon,
  UserCheckIcon,
  UserCircleIcon,
  UserDollarIcon,
  UserEditIcon,
  UserEditBulkIcon,
  UserEditFilledIcon,
  UserFilledIcon,
  UserIdIcon,
  UserSearchIcon,
  UserSettingsIcon,
  UserSettingsBulkIcon,
  UserSettingsFilledIcon,
  UserVerifyIcon,
  UserVerifyBulkIcon,
  UserVerifyFilledIcon,
  UserWarningIcon,
  UsersIcon,
  UsersFilledIcon,
  UsersGroupIcon,
  UsersGroupFilledIcon,
  UsersThreeIcon,
  UsersThreeFilledIcon,
  UsersTwoIcon,
  UsersTwoFilledIcon,
  VideoIcon,
  VisaIcon,
  VoiceIcon,
  VolumeIcon,
  WalletIcon,
  WalletMenuIcon,
  WalletMenuBulkIcon,
  WalletMenuFilledIcon,
  WarningIcon,
  WarningCircleIcon,
  WarningFilledIcon,
  WebProtectionIcon,
  WebProtectionFilledIcon,
  WebhookIcon,
  WorkflowIcon,
  WrenchIcon,
  WrenchFilledIcon,
  ZillowIcon,
  ZoomInIcon,
  ZoomOutIcon,
} from './generated';

export const icons = {
  "academic-cap": AcademicCapIcon,
  "agreement": AgreementIcon,
  "agreement-filled": AgreementFilledIcon,
  "ai-chat": AiChatIcon,
  "ai-suggestion": AiSuggestionIcon,
  "ai-suggestion-filled": AiSuggestionFilledIcon,
  "amex": AmexIcon,
  "analytics": AnalyticsIcon,
  "analytics-filled": AnalyticsFilledIcon,
  "api": ApiIcon,
  "api-bulk": ApiBulkIcon,
  "api-filled": ApiFilledIcon,
  "archive": ArchiveIcon,
  "arrow-down": ArrowDownIcon,
  "arrow-left": ArrowLeftIcon,
  "arrow-right": ArrowRightIcon,
  "arrow-up": ArrowUpIcon,
  "arrow-up-right": ArrowUpRightIcon,
  "attachment": AttachmentIcon,
  "audio-book": AudioBookIcon,
  "bank": BankIcon,
  "bank-card-share-money": BankCardShareMoneyIcon,
  "bank-card-share-money-bulk": BankCardShareMoneyBulkIcon,
  "bank-card-share-money-filled": BankCardShareMoneyFilledIcon,
  "bath": BathIcon,
  "bed": BedIcon,
  "blocked": BlockedIcon,
  "board-menu": BoardMenuIcon,
  "board-menu-bulk": BoardMenuBulkIcon,
  "board-menu-filled": BoardMenuFilledIcon,
  "board-pin": BoardPinIcon,
  "board-pin-bulk": BoardPinBulkIcon,
  "board-pin-filled": BoardPinFilledIcon,
  "board-tasks": BoardTasksIcon,
  "board-tasks-bulk": BoardTasksBulkIcon,
  "board-tasks-filled": BoardTasksFilledIcon,
  "book": BookIcon,
  "book-open": BookOpenIcon,
  "bookmark": BookmarkIcon,
  "bot": BotIcon,
  "briefcase": BriefcaseIcon,
  "briefcase-bulk": BriefcaseBulkIcon,
  "briefcase-filled": BriefcaseFilledIcon,
  "browser": BrowserIcon,
  "building": BuildingIcon,
  "building-filled": BuildingFilledIcon,
  "bunk-bed": BunkBedIcon,
  "calculator": CalculatorIcon,
  "calendar": CalendarIcon,
  "calendar-add-flip": CalendarAddFlipIcon,
  "calendar-check": CalendarCheckIcon,
  "calendar-close": CalendarCloseIcon,
  "calendar-filled": CalendarFilledIcon,
  "calendar-minus": CalendarMinusIcon,
  "calendar-percent": CalendarPercentIcon,
  "calendar-question": CalendarQuestionIcon,
  "calendar-star": CalendarStarIcon,
  "calendar-sync": CalendarSyncIcon,
  "calendar-user": CalendarUserIcon,
  "card-wallet": CardWalletIcon,
  "card-wallet-bulk": CardWalletBulkIcon,
  "card-wallet-filled": CardWalletFilledIcon,
  "cards": CardsIcon,
  "cards-bulk": CardsBulkIcon,
  "cards-filled": CardsFilledIcon,
  "cashier": CashierIcon,
  "cashier-bulk": CashierBulkIcon,
  "cashier-filled": CashierFilledIcon,
  "chart": ChartIcon,
  "chart-column": ChartColumnIcon,
  "chart-line": ChartLineIcon,
  "chart-line-filled": ChartLineFilledIcon,
  "chat": ChatIcon,
  "chat-add": ChatAddIcon,
  "chat-off": ChatOffIcon,
  "chat-question": ChatQuestionIcon,
  "chat-text": ChatTextIcon,
  "check": CheckIcon,
  "check-badge": CheckBadgeIcon,
  "check-circle": CheckCircleIcon,
  "check-double": CheckDoubleIcon,
  "check-list": CheckListIcon,
  "check-square": CheckSquareIcon,
  "check-square-filled": CheckSquareFilledIcon,
  "chemistry-flask": ChemistryFlaskIcon,
  "chevron-down": ChevronDownIcon,
  "chevron-left": ChevronLeftIcon,
  "chevron-right": ChevronRightIcon,
  "chevron-up": ChevronUpIcon,
  "chevrons-left": ChevronsLeftIcon,
  "chevrons-right": ChevronsRightIcon,
  "chevrons-up-down": ChevronsUpDownIcon,
  "circle": CircleIcon,
  "city": CityIcon,
  "city-bulk": CityBulkIcon,
  "city-filled": CityFilledIcon,
  "clap": ClapIcon,
  "clipboard": ClipboardIcon,
  "clipboard-clock": ClipboardClockIcon,
  "clipboard-clock-filled": ClipboardClockFilledIcon,
  "clock": ClockIcon,
  "clock-clockwise": ClockClockwiseIcon,
  "clock-filled": ClockFilledIcon,
  "clock-presentation": ClockPresentationIcon,
  "clock-world": ClockWorldIcon,
  "close": CloseIcon,
  "close-circle": CloseCircleIcon,
  "cloud": CloudIcon,
  "cloud-check": CloudCheckIcon,
  "cloud-download": CloudDownloadIcon,
  "cloud-download-bulk": CloudDownloadBulkIcon,
  "cloud-download-filled": CloudDownloadFilledIcon,
  "cloud-server": CloudServerIcon,
  "cloud-upload": CloudUploadIcon,
  "code": CodeIcon,
  "coins": CoinsIcon,
  "collapse": CollapseIcon,
  "command": CommandIcon,
  "compass": CompassIcon,
  "computer": ComputerIcon,
  "computer-dollar": ComputerDollarIcon,
  "computer-dollar-filled": ComputerDollarFilledIcon,
  "connected-cable": ConnectedCableIcon,
  "copy": CopyIcon,
  "credit-card": CreditCardIcon,
  "credit-card-edit": CreditCardEditIcon,
  "credit-card-filled": CreditCardFilledIcon,
  "dashboard": DashboardIcon,
  "dashboard-filled": DashboardFilledIcon,
  "database": DatabaseIcon,
  "database-import": DatabaseImportIcon,
  "database-import-filled": DatabaseImportFilledIcon,
  "delete": DeleteIcon,
  "delivery": DeliveryIcon,
  "discount": DiscountIcon,
  "discover": DiscoverIcon,
  "divide": DivideIcon,
  "document": DocumentIcon,
  "document-add": DocumentAddIcon,
  "document-add-bulk": DocumentAddBulkIcon,
  "document-add-filled": DocumentAddFilledIcon,
  "document-attachment": DocumentAttachmentIcon,
  "document-attachment-filled": DocumentAttachmentFilledIcon,
  "document-bulk": DocumentBulkIcon,
  "document-check": DocumentCheckIcon,
  "document-clock": DocumentClockIcon,
  "document-download": DocumentDownloadIcon,
  "document-edit": DocumentEditIcon,
  "document-edit-bulk": DocumentEditBulkIcon,
  "document-edit-filled": DocumentEditFilledIcon,
  "document-export": DocumentExportIcon,
  "document-filled": DocumentFilledIcon,
  "document-pdf": DocumentPdfIcon,
  "document-remove": DocumentRemoveIcon,
  "document-text": DocumentTextIcon,
  "document-upload": DocumentUploadIcon,
  "document-zip": DocumentZipIcon,
  "dog": DogIcon,
  "dollar": DollarIcon,
  "dollar-circle": DollarCircleIcon,
  "dollar-square": DollarSquareIcon,
  "dollar-up": DollarUpIcon,
  "dollar-up-bulk": DollarUpBulkIcon,
  "dollar-up-filled": DollarUpFilledIcon,
  "door": DoorIcon,
  "door-open": DoorOpenIcon,
  "download": DownloadIcon,
  "download-filled": DownloadFilledIcon,
  "drag-vertical": DragVerticalIcon,
  "droplet": DropletIcon,
  "edit": EditIcon,
  "edit-square": EditSquareIcon,
  "expand": ExpandIcon,
  "external-link": ExternalLinkIcon,
  "eye": EyeIcon,
  "eye-off": EyeOffIcon,
  "face-id-lock": FaceIdLockIcon,
  "face-id-lock-bulk": FaceIdLockBulkIcon,
  "face-id-lock-filled": FaceIdLockFilledIcon,
  "filter": FilterIcon,
  "filter-clear": FilterClearIcon,
  "fingerprint": FingerprintIcon,
  "fingerprint-filled": FingerprintFilledIcon,
  "flash": FlashIcon,
  "folder": FolderIcon,
  "folder-add": FolderAddIcon,
  "folder-blocked": FolderBlockedIcon,
  "folder-filled": FolderFilledIcon,
  "folder-library": FolderLibraryIcon,
  "folder-library-filled": FolderLibraryFilledIcon,
  "folder-lock": FolderLockIcon,
  "folder-open": FolderOpenIcon,
  "folder-transfer": FolderTransferIcon,
  "fullscreen": FullscreenIcon,
  "fullscreen-exit": FullscreenExitIcon,
  "gift": GiftIcon,
  "globe": GlobeIcon,
  "globe-filled": GlobeFilledIcon,
  "grid": GridIcon,
  "hashtag": HashtagIcon,
  "help-circle": HelpCircleIcon,
  "history": HistoryIcon,
  "home": HomeIcon,
  "home-bulk": HomeBulkIcon,
  "home-filled": HomeFilledIcon,
  "home-fun": HomeFunIcon,
  "home-fun-bulk": HomeFunBulkIcon,
  "home-fun-filled": HomeFunFilledIcon,
  "home-search": HomeSearchIcon,
  "idea": IdeaIcon,
  "image": ImageIcon,
  "image-missing": ImageMissingIcon,
  "inbox": InboxIcon,
  "inbox-filled": InboxFilledIcon,
  "info-circle": InfoCircleIcon,
  "invoice": InvoiceIcon,
  "key": KeyIcon,
  "key-filled": KeyFilledIcon,
  "layers": LayersIcon,
  "layers-add": LayersAddIcon,
  "legal-hammer": LegalHammerIcon,
  "license": LicenseIcon,
  "link": LinkIcon,
  "link-add": LinkAddIcon,
  "list": ListIcon,
  "list-bullet": ListBulletIcon,
  "list-number": ListNumberIcon,
  "loading": LoadingIcon,
  "location": LocationIcon,
  "lock": LockIcon,
  "lock-square": LockSquareIcon,
  "logout": LogoutIcon,
  "magic-selection": MagicSelectionIcon,
  "magic-wand": MagicWandIcon,
  "mail": MailIcon,
  "mail-account": MailAccountIcon,
  "mail-account-filled": MailAccountFilledIcon,
  "mail-ai": MailAiIcon,
  "mail-bulk": MailBulkIcon,
  "mail-check": MailCheckIcon,
  "mail-close": MailCloseIcon,
  "mail-document": MailDocumentIcon,
  "mail-document-filled": MailDocumentFilledIcon,
  "mail-edit": MailEditIcon,
  "mail-filled": MailFilledIcon,
  "mail-open": MailOpenIcon,
  "mail-open-bulk": MailOpenBulkIcon,
  "mail-open-filled": MailOpenFilledIcon,
  "mail-receive": MailReceiveIcon,
  "mail-receive-bulk": MailReceiveBulkIcon,
  "mail-receive-filled": MailReceiveFilledIcon,
  "mail-send": MailSendIcon,
  "mail-send-bulk": MailSendBulkIcon,
  "mail-send-filled": MailSendFilledIcon,
  "map": MapIcon,
  "mastercard": MastercardIcon,
  "megaphone": MegaphoneIcon,
  "megaphone-filled": MegaphoneFilledIcon,
  "menu": MenuIcon,
  "minus": MinusIcon,
  "minus-circle": MinusCircleIcon,
  "mobile": MobileIcon,
  "mobile-code": MobileCodeIcon,
  "mobile-send": MobileSendIcon,
  "money": MoneyIcon,
  "money-bag": MoneyBagIcon,
  "money-exchange": MoneyExchangeIcon,
  "money-exchange-filled": MoneyExchangeFilledIcon,
  "money-filled": MoneyFilledIcon,
  "money-receive": MoneyReceiveIcon,
  "money-send": MoneySendIcon,
  "money-send-circle": MoneySendCircleIcon,
  "moon": MoonIcon,
  "more-horizontal": MoreHorizontalIcon,
  "more-horizontal-circle": MoreHorizontalCircleIcon,
  "more-vertical": MoreVerticalIcon,
  "music-note": MusicNoteIcon,
  "network-edit": NetworkEditIcon,
  "note": NoteIcon,
  "note-filled": NoteFilledIcon,
  "notification": NotificationIcon,
  "notification-bulk": NotificationBulkIcon,
  "notification-filled": NotificationFilledIcon,
  "notification-off": NotificationOffIcon,
  "office": OfficeIcon,
  "office-filled": OfficeFilledIcon,
  "package": PackageIcon,
  "paint-brush": PaintBrushIcon,
  "palette": PaletteIcon,
  "paper-curved": PaperCurvedIcon,
  "paper-curved-bulk": PaperCurvedBulkIcon,
  "paper-curved-filled": PaperCurvedFilledIcon,
  "parking": ParkingIcon,
  "password": PasswordIcon,
  "pause-circle": PauseCircleIcon,
  "payment": PaymentIcon,
  "play": PlayIcon,
  "play-circle": PlayCircleIcon,
  "plug": PlugIcon,
  "plug-filled": PlugFilledIcon,
  "plus": PlusIcon,
  "plus-circle": PlusCircleIcon,
  "printer": PrinterIcon,
  "pushpin": PushpinIcon,
  "pushpin-filled": PushpinFilledIcon,
  "quickbooks": QuickbooksIcon,
  "receipt": ReceiptIcon,
  "receipt-dollar": ReceiptDollarIcon,
  "receipt-dollar-filled": ReceiptDollarFilledIcon,
  "receipt-filled": ReceiptFilledIcon,
  "receipt-success": ReceiptSuccessIcon,
  "redo": RedoIcon,
  "refresh": RefreshIcon,
  "refresh-filled": RefreshFilledIcon,
  "repeat": RepeatIcon,
  "repeat-bulk": RepeatBulkIcon,
  "repeat-filled": RepeatFilledIcon,
  "reports-analysis": ReportsAnalysisIcon,
  "ringtone": RingtoneIcon,
  "rocket": RocketIcon,
  "rotate-clockwise": RotateClockwiseIcon,
  "ruler": RulerIcon,
  "safe": SafeIcon,
  "save": SaveIcon,
  "savings": SavingsIcon,
  "scissors": ScissorsIcon,
  "search": SearchIcon,
  "search-list": SearchListIcon,
  "send": SendIcon,
  "send-filled": SendFilledIcon,
  "settings": SettingsIcon,
  "settings-filled": SettingsFilledIcon,
  "settings-gear": SettingsGearIcon,
  "settings-gear-bulk": SettingsGearBulkIcon,
  "settings-gear-filled": SettingsGearFilledIcon,
  "share": ShareIcon,
  "shield": ShieldIcon,
  "shield-add": ShieldAddIcon,
  "shield-blocked": ShieldBlockedIcon,
  "shield-check": ShieldCheckIcon,
  "shield-check-filled": ShieldCheckFilledIcon,
  "shield-done": ShieldDoneIcon,
  "shield-done-bulk": ShieldDoneBulkIcon,
  "shield-done-filled": ShieldDoneFilledIcon,
  "shield-user": ShieldUserIcon,
  "shield-user-bulk": ShieldUserBulkIcon,
  "shield-user-filled": ShieldUserFilledIcon,
  "shield-warning": ShieldWarningIcon,
  "sidebar-agreement": SidebarAgreementIcon,
  "sidebar-building": SidebarBuildingIcon,
  "sidebar-calendar": SidebarCalendarIcon,
  "sidebar-chart": SidebarChartIcon,
  "sidebar-clock": SidebarClockIcon,
  "sidebar-document": SidebarDocumentIcon,
  "sidebar-history": SidebarHistoryIcon,
  "sidebar-home": SidebarHomeIcon,
  "sidebar-inbox": SidebarInboxIcon,
  "sidebar-left": SidebarLeftIcon,
  "sidebar-people": SidebarPeopleIcon,
  "sidebar-pin": SidebarPinIcon,
  "sidebar-pin-filled": SidebarPinFilledIcon,
  "sidebar-tasks": SidebarTasksIcon,
  "sidebar-unit": SidebarUnitIcon,
  "sidebar-user": SidebarUserIcon,
  "sidebar-user-active": SidebarUserActiveIcon,
  "sidebar-user-inactive": SidebarUserInactiveIcon,
  "sidebar-vendor": SidebarVendorIcon,
  "sidebar-views": SidebarViewsIcon,
  "sidebar-wallet": SidebarWalletIcon,
  "sidebar-work": SidebarWorkIcon,
  "signature": SignatureIcon,
  "sort": SortIcon,
  "sort-down": SortDownIcon,
  "sort-up": SortUpIcon,
  "sparkles": SparklesIcon,
  "star": StarIcon,
  "star-filled": StarFilledIcon,
  "star-magic-glow": StarMagicGlowIcon,
  "star-magic-glow-filled": StarMagicGlowFilledIcon,
  "stop": StopIcon,
  "stop-circle": StopCircleIcon,
  "stop-filled": StopFilledIcon,
  "store": StoreIcon,
  "structure": StructureIcon,
  "sun": SunIcon,
  "swap-horizontal": SwapHorizontalIcon,
  "swap-horizontal-filled": SwapHorizontalFilledIcon,
  "table": TableIcon,
  "table-filled": TableFilledIcon,
  "tablet": TabletIcon,
  "tag": TagIcon,
  "target": TargetIcon,
  "target-filled": TargetFilledIcon,
  "target-search": TargetSearchIcon,
  "target-search-bulk": TargetSearchBulkIcon,
  "target-search-filled": TargetSearchFilledIcon,
  "task": TaskIcon,
  "task-add": TaskAddIcon,
  "task-bulk": TaskBulkIcon,
  "task-check": TaskCheckIcon,
  "task-edit": TaskEditIcon,
  "task-filled": TaskFilledIcon,
  "task-list": TaskListIcon,
  "taxes": TaxesIcon,
  "telephone": TelephoneIcon,
  "text-align-left": TextAlignLeftIcon,
  "text-bold": TextBoldIcon,
  "text-italic": TextItalicIcon,
  "thumb-down": ThumbDownIcon,
  "thumb-up": ThumbUpIcon,
  "tools": ToolsIcon,
  "undo": UndoIcon,
  "upload": UploadIcon,
  "user": UserIcon,
  "user-add": UserAddIcon,
  "user-blocked": UserBlockedIcon,
  "user-check": UserCheckIcon,
  "user-circle": UserCircleIcon,
  "user-dollar": UserDollarIcon,
  "user-edit": UserEditIcon,
  "user-edit-bulk": UserEditBulkIcon,
  "user-edit-filled": UserEditFilledIcon,
  "user-filled": UserFilledIcon,
  "user-id": UserIdIcon,
  "user-search": UserSearchIcon,
  "user-settings": UserSettingsIcon,
  "user-settings-bulk": UserSettingsBulkIcon,
  "user-settings-filled": UserSettingsFilledIcon,
  "user-verify": UserVerifyIcon,
  "user-verify-bulk": UserVerifyBulkIcon,
  "user-verify-filled": UserVerifyFilledIcon,
  "user-warning": UserWarningIcon,
  "users": UsersIcon,
  "users-filled": UsersFilledIcon,
  "users-group": UsersGroupIcon,
  "users-group-filled": UsersGroupFilledIcon,
  "users-three": UsersThreeIcon,
  "users-three-filled": UsersThreeFilledIcon,
  "users-two": UsersTwoIcon,
  "users-two-filled": UsersTwoFilledIcon,
  "video": VideoIcon,
  "visa": VisaIcon,
  "voice": VoiceIcon,
  "volume": VolumeIcon,
  "wallet": WalletIcon,
  "wallet-menu": WalletMenuIcon,
  "wallet-menu-bulk": WalletMenuBulkIcon,
  "wallet-menu-filled": WalletMenuFilledIcon,
  "warning": WarningIcon,
  "warning-circle": WarningCircleIcon,
  "warning-filled": WarningFilledIcon,
  "web-protection": WebProtectionIcon,
  "web-protection-filled": WebProtectionFilledIcon,
  "webhook": WebhookIcon,
  "workflow": WorkflowIcon,
  "wrench": WrenchIcon,
  "wrench-filled": WrenchFilledIcon,
  "zillow": ZillowIcon,
  "zoom-in": ZoomInIcon,
  "zoom-out": ZoomOutIcon,
};
